export default {
  path: '/newsConfirm',
  auth: true,
  preload: false,
  key: 'news',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};